import React from 'react';
import PropTypes from 'prop-types';
import Payment from '@material-ui/icons/Payment';
import OpenInNew from '@material-ui/icons/OpenInNew';
import LocalOffer from '@material-ui/icons/LocalOffer';
import DateRange from '@material-ui/icons/DateRange';

import { propTypes as i18nPropTypes } from '../../../../../hocs/intlEquipped';
import { paymentPropType, productPropType } from '../../../../../types/subscription';
import DetailInlineSection from '../DetailInlineSection';
import { formatRecurringBilling, getPriceAndDateByConditions } from '../helpers';
import Button from '../../../../Buttons/Button';
import Link from '../../../../Link';
import { useConfigValue } from '../../../../../hooks/useConfigValue';

const NonInstantDetailsContent = ({ product, payment, theme, i18n, openInvoicesModal }) => {
    const { formatMessage } = i18n;
    const { price, date } = getPriceAndDateByConditions({ product, payment, i18n });
    const recurringBilling = formatRecurringBilling({ product, payment, i18n });
    const { myPage } = useConfigValue();
    const nonInstantPaymentHelpUrl = myPage?.nonInstantPaymentHelpUrl;
    return (
        <>
            { recurringBilling && (
                <DetailInlineSection
                    detail={ recurringBilling }
                    icon={{ component: <LocalOffer className={ theme.detailIcon } /> }}
                    title={ formatMessage('subscription.priceSection') }
                    theme={ theme }
                />
            ) }
            { price && (
                <DetailInlineSection
                    detail={ price }
                    icon={{ component: <Payment className={ theme.detailIcon } /> }}
                    title={ formatMessage('subscription.toPaySection') }
                    theme={ theme }
                />
            ) }
            { date && (
                <DetailInlineSection
                    detail={ (
                        <div className={ theme.invoiceInfo }>
                            {formatMessage('payment.invoice.paymentMethodInfo')}
                            <Button
                                variant="text"
                                className={ theme.invoiceButton }
                                onClick={ openInvoicesModal }
                                testId="open-invoice-modal-action"
                            >
                                {formatMessage('payment.invoice.linkText')}
                            </Button>
                        </div>
                    ) }
                    icon={{ component: <DateRange className={ theme.detailIcon } /> }}
                    title={ formatMessage('subscription.nextPaymentSection') }
                    theme={ theme }
                />
            ) }
            { nonInstantPaymentHelpUrl && (
                <Link className={ theme.invoiceHelp } href={ nonInstantPaymentHelpUrl } target="_blank">
                    <span className={ theme.invoiceHelpWrapper } data-testid="invoice-help-action">
                        <span>{formatMessage('payment.invoice.helpText')}</span>
                        <OpenInNew className={ theme.invoiceHelpIcon } />
                    </span>
                </Link>
            )}
        </>
    );
};

NonInstantDetailsContent.propTypes = {
    payment: paymentPropType.isRequired,
    product: productPropType.isRequired,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
    openInvoicesModal: PropTypes.func.isRequired,
};

export default NonInstantDetailsContent;
